import { render, staticRenderFns } from "./EditorTipTap.vue?vue&type=template&id=ddd1343a&lang=pug&"
import script from "./EditorTipTap.vue?vue&type=script&lang=js&"
export * from "./EditorTipTap.vue?vue&type=script&lang=js&"
import style0 from "./EditorTipTap.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports